/** Word card: pinyin, Russian, example, «+ В карточки». `compact` (reader popover) drops the example. */
import { Icon } from '../../ui/Icon.tsx';
import { canSpeak, speak } from '../../ui/speech.ts';

export interface WordInfo {
  surface: string;
  pinyin?: string;
  ru?: string;
  pos?: string;
  hskLevel?: number | null;
  example?: { text: string; ru: string };
}

export function WordCard({
  word,
  speechLang,
  added,
  onAdd,
  compact = false,
}: {
  word: WordInfo;
  speechLang: string;
  added: boolean;
  onAdd: (() => void) | null;
  compact?: boolean;
}) {
  return (
    <article className={`card card--raised word-card${compact ? ' word-card--compact' : ''}`} aria-label={`Слово ${word.surface}`}>
      <div className="word-card__head">
        <span className="word-card__word han" lang={speechLang}>
          {word.surface}
        </span>
        {word.hskLevel ? <span className="chip">HSK {word.hskLevel}</span> : null}
        {canSpeak() && (
          <button
            type="button"
            className="sound-btn"
            onClick={() => speak(word.surface, speechLang)}
            aria-label="Произнести"
          >
            <Icon name="speaker" size={20} />
          </button>
        )}
      </div>
      {(word.pinyin || word.pos) && (
        <p className="t-meta">{[word.pinyin, word.pos].filter(Boolean).join(' · ')}</p>
      )}
      <p className="word-card__ru">{word.ru ?? 'Перевода пока нет — спросите учителя.'}</p>
      {word.example && !compact && (
        <div className="word-card__example">
          <p className="han" lang={speechLang}>
            {word.example.text}
          </p>
          <p className="t-meta">{word.example.ru}</p>
        </div>
      )}
      {onAdd && (
        <button type="button" className="btn btn--primary btn--block word-card__add" onClick={onAdd} disabled={added}>
          <Icon name={added ? 'check' : 'plus'} size={20} />
          {added ? 'Уже в карточках' : 'В карточки'}
        </button>
      )}
    </article>
  );
}
